/**
 * Glasnu productkaart — quick view.
 *
 * Eén gedelegeerde listener op document in plaats van een custom element per
 * kaart: een collectiepagina met vijftig kaarten kost zo nog steeds één
 * listener, en kaarten die de Theme Editor opnieuw rendert werken direct mee
 * zonder herinitialisatie.
 *
 * De knop opent hier nog niets. Hij verstuurt een `glasnu:quick-view` event
 * met de productgegevens; de quick view zelf (Modal of Drawer uit /design)
 * bestaat nog niet. Zolang niemand luistert, valt de klik terug op de
 * productpagina — de knop is dus nooit een dood eind.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quick-view]');
  if (!button) return;

  const detail = {
    url: button.dataset.productUrl,
    title: button.dataset.productTitle,
  };

  // cancelable: een luisteraar die de quick view daadwerkelijk opent roept
  // preventDefault() aan en houdt de bezoeker op de pagina.
  const opened = !document.dispatchEvent(
    new CustomEvent('glasnu:quick-view', { detail, cancelable: true, bubbles: true })
  );

  if (!opened && detail.url) {
    window.location.href = detail.url;
  }
});


// Product card gallery: arrows, keyboard navigation and mobile swipe.
(() => {
  const frames = new WeakSet();

  const showSlide = (frame, nextIndex) => {
    const images = [...frame.querySelectorAll('.gn-product-card__image')];
    if (images.length < 2) return;

    const index = (nextIndex + images.length) % images.length;
    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === index);
      image.setAttribute('aria-hidden', imageIndex === index ? 'false' : 'true');
    });

    frame.dataset.galleryIndex = String(index);
    const current = frame.querySelector('[data-card-gallery-current]');
    if (current) current.textContent = String(index + 1);
  };

  const changeSlide = (frame, direction) => {
    const current = Number(frame.dataset.galleryIndex || 0);
    showSlide(frame, current + direction);
  };

  const initFrame = (frame) => {
    if (frames.has(frame)) return;
    const images = frame.querySelectorAll('.gn-product-card__image');
    if (images.length < 2) return;

    frames.add(frame);
    frame.classList.add('is-gallery-ready');
    frame.tabIndex = 0;
    frame.setAttribute('role', 'group');
    frame.setAttribute('aria-label', 'Productafbeeldingen');
    showSlide(frame, 0);

    let startX = 0;
    let startY = 0;
    let swiped = false;

    frame.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      swiped = false;
    });

    frame.addEventListener('pointerup', (event) => {
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) > 36 && Math.abs(deltaX) > Math.abs(deltaY)) {
        swiped = true;
        changeSlide(frame, deltaX < 0 ? 1 : -1);
        event.preventDefault();
        event.stopPropagation();
      }
    });

    frame.addEventListener('click', (event) => {
      if (event.target.closest('[data-card-gallery-prev], [data-card-gallery-next]')) return;
      if (swiped) {
        swiped = false;
        event.preventDefault();
        return;
      }
      const link = frame.closest('.gn-product-card')?.querySelector('.gn-product-card__link');
      if (link?.href) window.location.href = link.href;
    });

    frame.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      changeSlide(frame, event.key === 'ArrowRight' ? 1 : -1);
    });
  };

  const initGalleries = (root = document) => {
    root.querySelectorAll('.gn-product-card__frame').forEach(initFrame);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-gallery-prev], [data-card-gallery-next]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const frame = button.closest('.gn-product-card__frame');
    if (frame) changeSlide(frame, button.hasAttribute('data-card-gallery-next') ? 1 : -1);
  });

  initGalleries();
  new MutationObserver(() => initGalleries()).observe(document.body, { childList: true, subtree: true });
})();
